import { chainReducers } from 'src/utils/chainReducers';
import { uiModalReducer } from 'src/react/common/reducers/uiModalReducer';
import { uiPopoverReducer } from 'src/react/common/reducers/uiPopoverReducer';

export const uiReducer = chainReducers(
    uiModalReducer,
    uiPopoverReducer,
);
